import React from 'react';
import ButtonLink from '../ButtonLink/ButtonLink';
import { Phrases } from '../../utilities/constants/phrases';
import { ButtonLinkAppearance } from '../ButtonLink/types';
import AdsBanner, { Props as AdSenseBannerProps } from '../AdsBanner/AdsBanner';
import { useOpenSubscriptionPopup } from '../../hooks/popup/useOpenSubscriptionPopup';

interface Props {
  BannerProps: AdSenseBannerProps;
}

const AdsContainer: React.FC<Props> = ({ BannerProps }) => {
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  return (
    <div>
      <AdsBanner {...BannerProps} />
      <div className='ta-center mt-xxs'>
        <ButtonLink
          onClick={handleOpenSubscriptionPopup}
          appearance={ButtonLinkAppearance.SECONDARY}>
          {Phrases.REMOVE_ADS_BUTTON_LABEL}
        </ButtonLink>
      </div>
    </div>
  );
};

export default AdsContainer;
